// @ts-check
/**
 * Define the breakpoint names in mytradera
 */
export const BPOINT = {
    small: 'small',
    medium: 'medium',
    XLarge: 'XLarge',
    XXLarge: 'XXLarge'
};

/**
 * Breakpoint definitions;
 */
export const breakPoints = {
    [BPOINT.small]: {
        min: 0,
        max: 767,
        name: BPOINT.small
    },
    [BPOINT.medium]: {
        min: 768,
        max: 1024,
        name: BPOINT.medium
    },
    [BPOINT.XLarge]: {
        min: 1025,
        max: 1249,
        name: BPOINT.XLarge
    },
    [BPOINT.XXLarge]: {
        min: 1250,
        max: 100000,
        name: BPOINT.XXLarge
    }
};

export const currentBreakpoint = () => {
    const windowWidth = window.innerWidth;
    return Object.keys(breakPoints).filter(i => {
        const bp = breakPoints[i];
        if (windowWidth >= bp.min && windowWidth <= bp.max) {
            return true;
        }
    });
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/constants/breakpoints.js